import { ConfirmationDialog } from 'components/ConfirmationDialog';
import { ModalDialog } from 'components/ModalDialog';
import { TableLoader } from 'components/TableLoader';
import type { RequestStatus } from 'features/request/requestSlice';
import { IconAlert, Informer, Table } from 'uikit';
import type { TableRow, TableColumn, SelectedFilters, Filters } from 'uikit';

import type { RefObject } from 'react';
import { useCallback, useState } from 'react';

import Styles from './BimAddOtherStyles.module.css';

type TBimAddOthers<T extends TableRow> = {
    modalTitle: string;
    modalConfirmLabel: string;
    cancelTextHeader: string;
    textConfirmation: JSX.Element | string;
    onConfirm: () => void;
    onCancel: () => void;
    haveCheckedOthers: boolean;
    isAddInProgress: boolean;
    informerMessage?: string;
    tableColumns: TableColumn<T>[];
    tableRows: T[];
    fetchStatus: RequestStatus;
    onFiltersUpdated?: (selectedFilters: SelectedFilters) => void;
    isInProgress?: boolean;
    leftPanel?: JSX.Element;
    tableFilters?: Filters<T>;
    tableRef?: RefObject<HTMLDivElement>;
};

const getAdditionalClass = ({ column, row }: any) => [column?.accessor, !row?.nestLevel ? 'groupHeader' : ''].join(' ');

export const BimAddOtherModal = <T extends TableRow>(props: TBimAddOthers<T>) => {
    const {
        modalTitle,
        modalConfirmLabel,
        onConfirm,
        onCancel,
        haveCheckedOthers,
        isAddInProgress,
        leftPanel,
        informerMessage,
        isInProgress = false,
        cancelTextHeader,
        textConfirmation,
        tableColumns,
        tableFilters,
        onFiltersUpdated,
        tableRows,
        fetchStatus,
        tableRef,
    } = props;

    const [isOpenWarningDialog, setIsOpenWarningDialog] = useState(false);

    const handleCancelWarningDialog = useCallback(() => {
        setIsOpenWarningDialog(false);
    }, []);

    const handleCancel = useCallback(() => {
        if (haveCheckedOthers) {
            setIsOpenWarningDialog(true);
        } else {
            onCancel();
        }
    }, [haveCheckedOthers, onCancel]);

    return (
        <ModalDialog
            isOpen
            title={modalTitle}
            onConfirm={onConfirm}
            onClose={handleCancel}
            withTitleCloseButton
            isOnClickOutsideDisable
            btnConfirmDisabled={!haveCheckedOthers}
            btnConfirmLabel={modalConfirmLabel}
            isCommit={isAddInProgress}
            className={Styles.modal}
            leftPanel={leftPanel}
        >
            {informerMessage && (
                <div className={Styles.informer}>
                    <Informer status="system" label={informerMessage} icon={IconAlert} />
                </div>
            )}

            <div className={Styles.tableContainer}>
                <Table
                    columns={tableColumns}
                    filters={tableFilters}
                    onFiltersUpdated={onFiltersUpdated}
                    rows={tableRows}
                    size="s"
                    className={`${isInProgress ? Styles.otherTableInProgress : Styles.otherTable} workOrderPrice`}
                    stickyHeader
                    emptyRowsPlaceholder={<TableLoader requestStatus={fetchStatus} />}
                    getAdditionalClassName={getAdditionalClass}
                    verticalAlign="center"
                    ref={tableRef}
                />
            </div>

            {isOpenWarningDialog && (
                <ConfirmationDialog
                    textHeader={cancelTextHeader}
                    textConfirmation={textConfirmation}
                    cancelButtonText="Не отменять"
                    confirmButtonText="Отменить"
                    isOpened={isOpenWarningDialog}
                    onSubmit={onCancel}
                    onClose={handleCancelWarningDialog}
                />
            )}
        </ModalDialog>
    );
};

BimAddOtherModal.displayName = 'BimAddOtherModal';
